<template>
  <div :style="wrapperStyle" class="scrollable-zone">
    <Zone name="main"></Zone>
  </div>
</template>

<script>
import Zone from '@/components/Zone'

export default {
  name: 'LayoutFullscreen',
  components: { Zone },
  computed: {
    wrapperStyle () {
      const res = {}
      const paddingtop = this.$store.state.layout.attributes.paddingtop
      if (paddingtop === undefined) {
        res['padding-top'] = '80px'
      } else {
        res['padding-top'] = paddingtop
      }
      const paddingbottom = this.$store.state.layout.attributes.paddingbottom
      if (paddingbottom === undefined) {
        res['padding-bottom'] = '80px'
      } else {
        res['padding-bottom'] = paddingbottom
      }
      return res
    }
  }
}
</script>

<style lang="sass">
</style>
